export enum ProSkillManagerAssessmentStatusType {
  LIVE = "LIVE",
  UPCOMING = "UPCOMING",
  ENDED = "ENDED"
}